import type { Tour } from 'nextstepjs';
import { createAccountCreationTour } from './account-creation-tour';
import { storeCreationTour } from './store-creation-tour';
import { getPluginInstallationTour } from './plugin-installation-tour';
import { brandingConfig } from '@/config/branding';

/**
 * Full onboarding tour with plugin installation
 * If no pluginName provided, skips plugin tour (generic onboarding)
 */
export function getCompleteOnboardingTour(pluginName?: string, appName = brandingConfig.appName): Tour[] {
  const accountTour = createAccountCreationTour(appName);
  if (pluginName) {
    return [accountTour, storeCreationTour, getPluginInstallationTour(pluginName)];
  }
  return [accountTour, storeCreationTour];
}

/**
 * Quick onboarding tour (account + store only)
 */
export function getQuickOnboardingTour(appName = brandingConfig.appName): Tour[] {
  return [createAccountCreationTour(appName), storeCreationTour];
}

/**
 * Store-only onboarding (for existing users)
 */
export function getStoreOnlyTour(): Tour[] {
  return [storeCreationTour];
}

/**
 * Plugin-only onboarding (for existing users)
 */
export function getPluginOnlyTour(pluginName?: string): Tour[] {
  return [getPluginInstallationTour(pluginName)];
}
